
export class LoginUsuarioDTO {

  constructor(
    public cdCentrus?: number,
    public sgSenha?: string,
    public nrFone?: number,
    public irAtivo?: Boolean,
    public noPessoa?: string,
    public noMae?: string,
    public noPai?: string,
    public irSexo?: string,
    public dsObs?: string
  ) {
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/login-usuarioDTO.ts